import {Component, Input, TemplateRef} from '@angular/core';

@Component({
  selector: 'ax-info-modal',
  templateUrl: './info-modal.component.html',
})
export class InfoModalComponent {
  @Input() content: TemplateRef<unknown>;
}
